import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/extras";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="FAQ"
              title="观影问答"
              desc="把大家最常问到的几个问题集中在这里。如果你想要的答案不在这几个问题里，也可以把本页当作了解影片的起点。"
              align="center"
            />
          </Reveal>

          <div className="mt-10 md:mt-12 space-y-3">
            {faqs.map((item, index) => {
              const isOpen = openId === item.id;
              return (
                <Reveal key={item.id} delay={index * 40}>
                  <div className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
                    <button
                      type="button"
                      onClick={() => toggle(item.id)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer hover:bg-primary-50/60 transition-colors"
                    >
                      <span className="font-heading text-base md:text-lg font-bold text-foreground-950">
                        {item.question}
                      </span>
                      <span
                        className={`w-8 h-8 flex items-center justify-center rounded-full shrink-0 transition-colors ${
                          isOpen
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-100 text-foreground-600"
                        }`}
                      >
                        <i
                          className={`${
                            isOpen ? "ri-subtract-line" : "ri-add-line"
                          } text-lg`}
                        />
                      </span>
                    </button>
                    <div
                      className="grid transition-all duration-300 ease-out"
                      style={{
                        gridTemplateRows: isOpen ? "1fr" : "0fr",
                      }}
                    >
                      <div className="overflow-hidden">
                        <p className="px-5 md:px-6 pb-5 text-sm md:text-base leading-relaxed text-foreground-600">
                          {item.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}